export const FOOTER = {
  root: "footer",
  about: "footer-about",
  faq: "footer-faq",
  privacy: "footer-privacy",
  terms: "footer-terms",
  contact: "footer-contact",
  market: "footer-market",
  categories: "footer-categories",
  email: "footer-email",
  phone: "footer-phone",
};

export const INFO_PAGE = {
  root: "info-page",
  back: "info-page-back",
};
